import React         from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { usePortal } from '../../../hooks';

const DraggableItem = (
    {
        index,
        id,
        useStaticPositioning = false,
        usePortaling = false,
        as = 'div',
        children,
        ...props
    } ) => {

    let [ portal, portalize ] = usePortal();

    return (

        <Draggable draggableId={ id } index={ index }>

            { ( provided, snapshot ) => {

                // fix positioning
                // https://github.com/atlassian/react-beautiful-dnd/issues/485
                if( useStaticPositioning && snapshot.isDragging ){

                    provided.draggableProps.style.position = 'static';
                }

                const Component = as ?? 'div';

                let child = (
                    <Component ref={ provided.innerRef }
                               { ...provided.draggableProps }
                               { ...provided.dragHandleProps }
                               { ...props }>

                        { children }

                    </Component>
                );

                if( usePortaling && snapshot.isDragging ){

                    // reorient positioning
                    // https://stackoverflow.com/a/56161824
                    // https://github.com/atlassian/react-beautiful-dnd/blob/master/stories/src/portal/portal-app.jsx
                    return portalize( child );

                } else {

                    return child;
                }

            } }
        </Draggable>
    );
};

export { DraggableItem };
